import React, { createContext, useContext, useState, useCallback } from "react";
import EnquiryWizard from "./EnquiryWizard";

/**
 * One "Start a Manufacturing Enquiry" journey, reachable from every CTA on
 * the site. openEnquiry({ interested_in: ["Shirts"] }) pre-selects fields.
 */
const EnquiryContext = createContext(null);
export const useEnquiry = () => useContext(EnquiryContext);

export default function EnquiryProvider({ children }) {
  const [state, setState] = useState({ open: false, prefill: null });
  const openEnquiry = useCallback((prefill = null) => setState({ open: true, prefill }), []);
  const closeEnquiry = useCallback(() => setState({ open: false, prefill: null }), []);

  return (
    <EnquiryContext.Provider value={{ openEnquiry, closeEnquiry }}>
      {children}
      {state.open && <EnquiryWizard prefill={state.prefill} onClose={closeEnquiry} />}
    </EnquiryContext.Provider>
  );
}
